import checkbox from '@/global/components/fields/Checkbox.vue'
import { api } from '@/global/services/api'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapGettersBase, mapActions: mapActionsBase } = createNamespacedHelpers('base/config')
const REFRESH_DELAY_IN_SECONDS = 15
const AUTO_REFRESH_TIMEOUT = 300
export default {
  name: 'CanBus',

  data () {
    return {
      refreshInterval: null,
      autoRefreshTimeout: null,
      autoRefreshState: false,
      disableAutoRefresh: false
    }
  },

  computed: {
    ...mapGettersBase(['userConfig']),

    canBusEditConfig () {
      return {
        title: this.$t('fleet/vehicle.canbus'),
        key: 'canBus',
        formData: this.formData?.item,
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        tabContent: [
          {
            component: this.tabActionsComponent,
            showEditButtons: false,
            showBack: false,
            title: this.$t('fleet/vehicle.canbus'),
            additional_buttons: [
              {
                component: checkbox,
                label: this.$t('base.automatic_refresh'),
                disabled: this.disableAutoRefresh,
                value: this.autoRefreshState,
                onChange: async (event) => {
                  const { value } = event || {}
                  await this.setAutoRefresh(value)
                }
              }
            ]
          },
          {
            component: this.columnsContentComponent,
            rows: [
              {
                component: this.canBusComponent,
                fieldsConfig: [
                  {
                    key: 'canbus_vehicle_speed',
                    label: this.$t('fleet/vehicle.canbus_vehicle_speed')
                  },
                  {
                    key: 'canbus_acceleration_pedal',
                    label: this.$t('fleet/vehicle.canbus_acceleration_pedal')
                  },
                  {
                    key: 'canbus_fuel_consumed',
                    label: this.$t('fleet/vehicle.canbus_fuel_consumed')
                  },
                  {
                    key: 'canbus_fuel_level_percentage',
                    label: this.$t('fleet/vehicle.canbus_fuel_level')
                  },
                  {
                    key: 'canbus_engine_rpm',
                    label: this.$t('fleet/vehicle.canbus_engine_rpm')
                  },
                  {
                    key: 'canbus_total_mileage',
                    label: this.$t('fleet/vehicle.canbus_total_mileage')
                  }
                ]
              },
              {
                columnsCount: 4,
                fields: [
                  {
                    key: 'canbus_fuel_level',
                    label: this.$t('fleet/vehicle.canbus_fuel_level'),
                    visible: true
                  },
                  {
                    key: 'canbus_engine_temperature',
                    label: this.$t('fleet/vehicle.canbus_engine_temperature'),
                    visible: true
                  },
                  {
                    key: 'canbus_door_status',
                    label: this.$t('fleet/vehicle.canbus_door_status'),
                    visible: true
                  },
                  {
                    key: 'canbus_cruise_control_active',
                    label: this.$t('fleet/vehicle.canbus_cruise_control_active'),
                    visible: true
                  },
                  {
                    key: 'canbus_service_distance',
                    label: this.$t('fleet/vehicle.canbus_service_distance'),
                    visible: true
                  },
                  {
                    key: 'canbus_brake_switch',
                    label: this.$t('fleet/vehicle.canbus_brake_switch'),
                    visible: true
                  },
                  {
                    key: 'canbus_vin',
                    label: this.$t('fleet/vehicle_attribute.vin'),
                    visible: true
                  },
                  {
                    key: 'canbus_driver1_state',
                    label: this.$t('fleet/vehicle.canbus_driver1_state'),
                    visible: true
                  },
                  {
                    key: 'canbus_driver2_state',
                    label: this.$t('fleet/vehicle.canbus_driver2_state'),
                    visible: true
                  },
                  {
                    key: 'canbus_driver1_card',
                    label: this.$t('fleet/vehicle.canbus_driver1_card'),
                    visible: true
                  },
                  {
                    key: 'canbus_driver2_card',
                    label: this.$t('fleet/vehicle.canbus_driver2_card'),
                    visible: true
                  },
                  {
                    key: 'canbus_dipped_headlights',
                    label: this.$t('fleet/vehicle.canbus_dipped_headlights'),
                    visible: true
                  },
                  {
                    key: 'canbus_full_beam_headlights',
                    label: this.$t('fleet/vehicle.canbus_full_beam_headlights'),
                    visible: true
                  },
                  {
                    key: 'canbus_driver_seatbelt',
                    label: this.$t('fleet/vehicle.canbus_driver_seatbelt'),
                    visible: true
                  },
                  {
                    key: 'canbus_passenger_seatbelt',
                    label: this.$t('fleet/vehicle.canbus_passenger_seatbelt'),
                    visible: true
                  },
                  {
                    key: 'canbus_handbrake',
                    label: this.$t('fleet/vehicle.canbus_handbrake'),
                    visible: true
                  },
                  {
                    key: 'canbus_oil_warning',
                    label: this.$t('fleet/vehicle.canbus_oil_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_coolant_warning',
                    label: this.$t('fleet/vehicle.canbus_coolant_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_handbrake_warning',
                    label: this.$t('fleet/vehicle.canbus_handbrake_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_engine_warning',
                    label: this.$t('fleet/vehicle.canbus_engine_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_brake_pads_warning',
                    label: this.$t('fleet/vehicle.canbus_brake_pads_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_esp_warning',
                    label: this.$t('fleet/vehicle.canbus_esp_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_glow_plug_warning',
                    label: this.$t('fleet/vehicle.canbus_glow_plug_warning'),
                    visible: true
                  },
                  {
                    key: 'canbus_adblue_level',
                    label: this.$t('fleet/vehicle.canbus_adblue_level'),
                    visible: true
                  },
                  {
                    key: 'canbus_engine_worktime',
                    label: this.$t('fleet/vehicle.canbus_engine_worktime'),
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  async created () {
    const { auto_refresh: autoRefresh } = this.userConfig?.fleet || {}
    this.autoRefreshState = autoRefresh === 'true'
  },

  methods: {
    ...mapActionsBase({ fetchBaseConfig: 'fetch' }),

    async setAutoRefresh (value) {
      this.autoRefreshState = !!value
      this.disableAutoRefresh = true
      this.stopAutoRefresh()

      await this.updateAutoRefresh(this.autoRefreshState)
      if (this.autoRefreshState) {
        const that = this
        this.refreshInterval = setInterval(async () => {
          if (that.$route?.params?.id) {
            const success = await that.fetch(that.$route.params.id)
            // Stop polling a vehicle that keeps failing to load (e.g. deleted or no longer accessible)
            // instead of repeating the same failed request every 15 seconds indefinitely.
            if (!success) {
              await that.setAutoRefresh(false)
            }
          }
        }, REFRESH_DELAY_IN_SECONDS * 1000)
      }

      this.autoRefreshTimeout = setTimeout(() => {
        this.disableAutoRefresh = false
      }, AUTO_REFRESH_TIMEOUT)
    },

    stopAutoRefresh () {
      clearInterval(this.refreshInterval)
      clearTimeout(this.autoRefreshTimeout)
    },

    async updateAutoRefresh (value) {
      try {
        const formData = new FormData()
        formData.append('auto_refresh', value)
        await api('fleet').post('vehicles/update-auto-refresh', formData)
        await this.fetchBaseConfig()
      }
      catch (exception) {
        console.error('Error occurred when tried to update auto refresh config. Exception: ', exception)
      }
    }
  }
}
